import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { destinations } from "@/data/destinations";
import { services } from "@/data/services";
import { useT } from "@/i18n";

export default function MobileMenu({ open, onClose }) {
  const { t } = useT();
  const groups = [
    ["destinations", destinations.map((d) => [`/destinations/${d.slug}`, d.name])],
    ["services", services.map((s) => [`/services/${s.slug}`, s.name])],
  ];
  return createPortal(
    <AnimatePresence>
      {open && (
        <motion.div data-lenis-prevent initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} className="fixed inset-0 z-[60] overflow-y-auto bg-navy px-6 pb-10 pt-6 lg:hidden" data-testid="mobile-menu">
          <div className="flex items-center justify-between">
            <img src="/brand/logo.webp" alt="Immistop crest" className="h-12 w-auto" />
            <button type="button" onClick={onClose} aria-label="Close menu" className="p-2 text-ivory" data-testid="mobile-menu-close-btn"><X className="h-6 w-6" /></button>
          </div>
          <Accordion type="single" collapsible className="mt-10">
            {groups.map(([k, items]) => (
              <AccordionItem key={k} value={k} className="border-ivory/15">
                <AccordionTrigger className="font-serif text-3xl font-normal text-ivory hover:no-underline [&>svg]:text-gold" data-testid={`mobile-${k}-trigger`}>{t(`nav.${k}`)}</AccordionTrigger>
                <AccordionContent>
                  <ul className="space-y-3 pb-2">
                    {items.map(([to, label]) => (
                      <li key={to}><Link to={to} onClick={onClose} className="text-[15px] text-ivory/80 hover:text-gold">{label}</Link></li>
                    ))}
                  </ul>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          <ul className="mt-2">
            {[["/about", "nav.about"], ["/insights", "nav.insights"], ["/faq", "nav.faq"], ["/contact", "nav.contact"], ["/eligibility", "cta.eligibilityShort"]].map(([to, k]) => (
              <li key={to} className="border-b border-ivory/15 py-4"><Link to={to} onClick={onClose} className="font-serif text-3xl text-ivory hover:text-gold" data-testid={`mobile-link-${to.slice(1)}`}>{t(k)}</Link></li>
            ))}
          </ul>
          <Link to="/contact" onClick={onClose} className="btn-gold mt-10 w-full" data-testid="mobile-book-btn"><span>{t("cta.book")}</span></Link>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  );
}
